import React, { useState, useMemo } from "react";
import InvoiceItem from "./InvoiceItem";
import Overheads from "./Overheads";
import Others from "./Others";
import "./settings.css";
import Inventory from "./inventory";
import CompanyInfo from "./company_info";
import { Building2, FileText, Gauge, Percent, Boxes } from "lucide-react";

const TABS = [
  { key: "CompanyInfo", label: "Company Info", icon: Building2 },
  { key: "Invoice Item", label: "Invoice Item", icon: FileText },
  { key: "Overheads", label: "Overheads", icon: Gauge },
  { key: "Others", label: "Others", icon: Percent },
  { key: "inventory", label: "Resources", icon: Boxes },
];

const Settings = () => {
  const [activeTab, setActiveTab] = useState("CompanyInfo");

  const renderTabContent = useMemo(() => {
    switch (activeTab) {
      case "CompanyInfo":
        return <CompanyInfo />;
      case "Invoice Item":
        return <InvoiceItem />;
      case "Overheads":
        return <Overheads />;
      case "Others":
        return <Others />;
      case "inventory":
        return <Inventory />;
      default:
        return <CompanyInfo />;
    }
  }, [activeTab]);

  return (
    <div className="settings-shell">
      {/* Page heading */}
      <header className="settings-head panel">
        <div className="title">
          <h2>Workspace Setup</h2>
          <p className="muted">
            Configure your company identity, invoice items, overheads, and more.
          </p>
        </div>
      </header>

      {/* Tabs */}
      <nav
        className="settings-tabs panel"
        role="tablist"
        aria-label="Settings Sections"
      >
        <div className="tabs-track">
          {TABS.map(({ key, label, icon: Icon }) => {
            const active = activeTab === key;
            return (
              <button
                key={key}
                id="tab1-btn" /* preserved id signature for compatibility */
                role="tab"
                aria-selected={active}
                aria-controls={`panel-${key}`}
                className={`tab-chip ${active ? "active" : ""}`}
                onClick={() => setActiveTab(key)}
              >
                <Icon size={16} />
                <span className="label">{label}</span>
                {active && <span className="glow" aria-hidden="true" />}
              </button>
            );
          })}
        </div>
      </nav>

      {/* Content */}
      <section
        className="tab-panel panel"
        role="tabpanel"
        id={`panel-${activeTab}`}
      >
        {renderTabContent}
      </section>
    </div>
  );
};

export default Settings;
